import { render } from "./SiteAccessChangeModal.vue?vue&type=template&id=5cae12ef"
import script from "./SiteAccessChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteAccessChangeModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteAccessChangeModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cae12ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cae12ef', __exports__)) {
    api.reload('5cae12ef', __exports__)
  }
  
  module.hot.accept("./SiteAccessChangeModal.vue?vue&type=template&id=5cae12ef", () => {
    api.rerender('5cae12ef', render)
  })

}


export default __exports__